(() => {
  if (!document.body?.classList.contains('template-product-default')) return;

  const hasVariantDeepLink = new URLSearchParams(window.location.search).has('variant');
  const selectOptionsLabel = 'Choose options';

  const selectedValues = (picker) =>
    Array.from(picker.querySelectorAll('[data-picker-field]')).map((field) => {
      if (field.dataset.pickerField === 'radio') {
        return field.querySelector('input:checked')?.value || '';
      }

      return field.querySelector('select')?.value || '';
    });

  const selectionIsComplete = (picker) => {
    const values = selectedValues(picker);
    return values.length > 0 && values.every(Boolean);
  };

  const resetInitialSelection = (picker) => {
    if (
      hasVariantDeepLink ||
      picker.dataset.disableSelectedVariantDefault !== 'true' ||
      picker.dataset.hasOnlyDefaultVariant === 'true'
    ) {
      return;
    }

    picker.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
    });
    picker.querySelectorAll('[data-picker-field="radio"]').forEach((field) => {
      field.dataset.selectedValue = '';
    });
    picker.querySelectorAll('[data-picker-field="select"]').forEach((field) => {
      const select = field.querySelector('select');
      if (select) select.value = '';
      field.dataset.selectedValue = '';
    });
    picker.querySelectorAll('.option-label--selected').forEach((label) => {
      label.textContent = '';
    });

    const wrapper = picker.closest('.m-main-product--wrapper');
    const variantInput = wrapper?.querySelector('.m-product-form--main [name="id"]');
    if (variantInput) variantInput.value = '';

    picker.updateButton?.(true, selectOptionsLabel);

    wrapper?.querySelectorAll('.m-product-dynamic-checkout').forEach((checkout) => {
      checkout.classList.add('disabled');
      checkout.setAttribute('aria-disabled', 'true');
    });

    document
      .querySelectorAll('sticky-atc[data-disable-selected-variant-default="true"] select[name="id"]')
      .forEach((select) => {
        select.value = '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
  };

  customElements.whenDefined('variant-picker').then(() => {
    const VariantPicker = customElements.get('variant-picker');
    const prototype = VariantPicker?.prototype;

    if (prototype && !prototype.tesevoManualSelectionPatched) {
      const originalUnavailable = prototype.setProductAsUnavailable;

      prototype.getSelectedVariant = function getSelectedVariantWithoutFallback() {
        const values = selectedValues(this);
        this.options = values.filter(Boolean);

        if (!selectionIsComplete(this)) {
          this.currentVariant = undefined;
          return;
        }

        this.currentVariant = getVariantFromOptionArray(this.productData, values);
      };

      prototype.setProductAsUnavailable = function setProductAsUnavailableAfterManualChoice() {
        if (!selectionIsComplete(this)) {
          this.updateButton(true, selectOptionsLabel);
          return;
        }

        originalUnavailable.call(this);
      };

      prototype.tesevoManualSelectionPatched = true;
    }

    document.querySelectorAll('variant-picker').forEach((picker) => {
      resetInitialSelection(picker);
      picker.addEventListener('change', () => {
        window.requestAnimationFrame(() => {
          const wrapper = picker.closest('.m-main-product--wrapper');
          const checkout = wrapper?.querySelector('.m-product-dynamic-checkout');
          const complete = selectionIsComplete(picker) && Boolean(picker.currentVariant?.available);

          checkout?.classList.toggle('disabled', !complete);
          checkout?.setAttribute('aria-disabled', String(!complete));
        });
      });
    });
  });
})();
